import { useEffect, useState } from "react";
import { Card, Badge, Stack, Row, Col } from "react-bootstrap";
import { CardTitle, CardDataLabel, CardDataValue } from "../components/card_components";
import { AppIcon } from "@/components/Icon";
import TableCellCurrency from "@/components/Table/cell_formats/TableCellCurrency";
import { getVirtualAccountsRequest } from "@/services/loanservices";

import ordinal from "ordinal";

export default function RepaymentDetails({ loanSummary, loanUUID }) {
  const [vaDetails, setVaDetails] = useState(null);

  useEffect(() => {
    if (loanUUID) {
      getVirtualAccountsRequest({ loanId: loanUUID })
        .then((resp) => {
          if (resp?.status) setVaDetails(resp?.results[0] || null);
        })
        .catch((err) => console.error("Error fetching virtual account details:", err));
    }
  }, [loanUUID]);

  return (
    <Card className="border-0 rounded-lg">
      <Card.Body>
        <Stack gap={2}>
          <Card.Title>
            <Stack direction="horizontal">
              <CardTitle title={"Repayment Details"} csx={"me-auto"} />
            </Stack>
          </Card.Title>

          <Stack gap={3}>
            <Row className="g-3">
              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Installment Amount"} />
                  <TableCellCurrency value={loanSummary?.installmentAmount || 0} />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Installment Frequency"} />
                  <CardDataValue title={loanSummary?.frequency || "-"} />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Installment Day"} />
                  <CardDataValue title={ordinal(Number(loanSummary?.cycleDay)) + " of every month" || "-"} />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Virtual Account IBAN"} />
                  <CardDataValue title={vaDetails?.account_number || "-"} />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Swift Code"} />
                  <CardDataValue title={vaDetails?.swift_code || "-"} />
                </Stack>
              </Col>
            </Row>
          </Stack>
          
          <hr className="my-2 border-primary-light" />

          <Stack direction="horizontal" gap={3}>
            <div>
              <Badge pill bg="success" className="p-2">
                <AppIcon name={"Transactions"} />
              </Badge>
            </div>

            <Stack gap={1}>
              <h6 className="mb-0">Repayment Mode</h6>
              <p className="text-sm text-[#6C727F]">
                {loanSummary?.repaymentMode ||
                  "We’ll automatically charge your payment through the gateway. If the full amount isn’t covered, the rest will be collected through Direct Debit."}
              </p>
            </Stack>
          </Stack>
        </Stack>
      </Card.Body>
    </Card>
  );
}
